// extracted by mini-css-extract-plugin
module.exports = {"modal":"_ur","closeBtn":"_us","header":"_ut"};